<template>
    <div :class="'PublicSelect_'+id +' publicSelectMain'">
        <div class="PublicSelectMask" v-if="isReadonly">
          
        </div>
        <el-select :class="['PublicSelect_Select', { 'is-error': IsError }]"  v-model="selectOptionsOrigin" :disabled="disabled" :placeholder="TagTextParm.placeholder">
            <el-option
            v-for="item in SelectData" 
            :key="item[SelectParm.key]"
            :label="item[SelectParm.label]"
            :value="item[SelectParm.value]"
            :disabled="item[SelectParm.disabled] || (GetIsIsAllowNullText && item[SelectParm.value] < 1)" @click.native="ChangeStr(item)">
            <span  v-if="SelectType==1">
                <span v-if="item[SelectParm.Top]>0"> 
                  <span style="float: left">{{ item[SelectParm.label] }}</span>
                    <span  :class="'top '+(item[SelectParm.Top]>2?'top-style-Big':'top-style-'+item[SelectParm.Top]  )  ">
                    {{$t(TagTextParm.TopText,{number:item[SelectParm.Top]})}}
                    </span>
                </span>
                <span v-else >
                  <span style="float: left" class="NoTOption">{{ item[SelectParm.label] }}</span>
                  <span class="top NoTOption-rigt" > {{ TagTextParm.NullTopText }}</span>
              </span>
            </span>
            <span v-else>
              <span style="float: left">{{ item[SelectParm.label] }}</span>
            </span>
            </el-option>
            <div slot="empty" class="empty-text">
              {{ $t('lbl_EMPBE_El_SELECT') }}
            </div>
        </el-select>
        <div v-if="!ExternalError && HasError" v-html="ErrorText" class="ErrorTextColor errorWidth" >
        </div>
        <div v-if="ExternalError" class="ErrorTextColor errorWidth">
          {{ ExternalErrorTextDisplay }}
        </div>
      
    </div>
  </template>
  
  <script>
  export default {
    props:{
      // 外部错误：由父组件根据 item.uPError 等字段传入，用于后端校验失败的高亮展示
      externalError: {
        type: Boolean,
        default: false
      },
      externalErrorText: {
        type: String,
        default: ''
      },
      IsAllowNullText:{
        type:Boolean,
        default:true
      },
      TagTextParm:{
          type:Object,
          default:function () {
            return {
              placeholder:this.$t("lbl_EMPBE_Companted_Tags_Placeother_Content"),
              errorText:this.$t("lbl_EMPBE_Companted_Tags_Requeid"),
              TopText:"lbl_EMPBE_Companted_Select_Top",
              NullTopText:"",
              NoTopErrorText:""//可以自定义一些错误提示
            }
          }
        },
        isMandatory:{
            type:Boolean,
            default:false
        },
        checkNull:{
            type:Boolean,
            default:false
        },
        id:{
          type:String,
          default:''
        },
        isReadonly:{
          type:Boolean,
          default:false
        },
        selectOptions:{
          type:String,
          default:undefined
        },
        SelectType:{
          type:Number,
          default:0 // 0:默认，1:带排名 
        },
        SelectParm:{
          type:Object,
          default:function () {
            return {
              key:"key",
              label:"label",
              value:"value",
              disabled:"disabled",
              Top:"Top"
            }
          }
        },
        SelectData:{
          type:Array,
          default:()=> [
              {key:1,value:1,label:'8',disabled:false,Top:1},
              {key:2,value:2,label:'7',disabled:false,Top:2},
              {key:3,value:3,label:'6',disabled:false,Top:3},
              {key:4,value:4,label:'5',disabled:false,Top:4},
              {key:5,value:5,label:'4',disabled:false,Top:5},
              {key:6,value:6,label:'3',disabled:false,Top:0},
              {key:7,value:7,label:'2',disabled:false,Top:1},
          
          ]
      },
      disabled: {
        type:Boolean,
        default:false
      }
    },
    data(){
        return {
          HasError:false,
          ErrorText:'',
          selectOptionsOrigin:''
          //readonlyStyleClass: 'readonly-style'
        }
    },
    mounted(){
      this.selectOptionsOrigin=this.selectOptions;
      if (this.checkNull) {
        this.CheMandatory();
      }
    },
    watch:{
      selectOptions(newVal){
        this.selectOptionsOrigin = newVal;
        this.CheMandatory();
      },
      checkNull: {
        handler(newVal) {
          if (newVal) {
            this.CheMandatory();
          }
        },
        immediate: true
      },
    },
    computed:{
      ExternalError() {
        return !!this.externalError;
      },
      ExternalErrorTextDisplay() {
        return this.externalErrorText || this.$t('lbl_EMPBE_PublicSelect_UpstreamOptionMissing');
      },
      IsError() {
        return this.HasError || this.ExternalError;
      },
      GetIsIsAllowNullText(){
          if(!this.IsAllowNullText && this.SelectType==1)
            return true;
          else
            return false;
      }
    },
    methods:{
      ChangeStr(item){
        this.GetIsAllowNullText(item[[this.SelectParm.Top]], item.disabled);
        if(this.selectOptionsOrigin){
            this.$emit("ChangeSelectStr",item)
        }
        
       
      },
      GetIsAllowNullText(value, disabled){
        if(!this.IsAllowNullText && this.SelectType==1)
        {
          if(value<1 && !disabled)
          {
                this.HasError=true;
                this.ErrorText=this.TagTextParm.NoTopErrorText;
                this.$emit("noticeErrorMethods",true)
          }else
          {
                this.HasError=false;
                this.ErrorText="";
                this.$emit("noticeErrorMethods",false)
          }
        }
      },
      CheMandatory(){
          this.HasError=false;
          this.ErrorText="";
          if(!this.isReadonly && this.isMandatory && !this.disabled)
          {
              if(!this.selectOptionsOrigin)
              {
                this.HasError=true;
                this.ErrorText=this.TagTextParm.errorText;
                this.$emit("noticeMethods")
              }
          }
      }
    }
  }
  </script>
<style lang="scss" scoped>
  .PublicSelectMask{
    width: 100%;
    height: 40px;
    position: absolute;
    z-index: 1;
  }
  .publicSelectMain{
    position: relative;
  }
  .el-select{
    width: 100%;
  }  
  ::v-deep .el-input__inner{
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-radius: 4px;
}

::v-deep .PublicSelect_Select.is-error .el-input__inner{
  border-color: #f56c6c !important;
}
.top{
  float: right;
  color: #8492a6;
  margin-left: 10px;
  font-feature-settings: 'liga' off, 'clig' off;
  /* Text/Paragraph 3 */
  font-size: 12px;
  font-style: italic;
  font-weight: 700;
    
}
.top-style-0
{
  color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
}
.top-style-1
{
  color: #FF3131;
}
.top-style-2
{
  color: #FF851A;
}
.top-style-Big
{
  color: #7366FF;
}
.ErrorTextColor{
  color: #f56c6c;
}
.errorWidth{
  
  max-width: 400px;
  font-size: 12px;
}
.NoTOption
{
  color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
}
.NoTOption-rigt{
color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
}
::v-deep .el-select .el-input.is-disabled .el-input__inner {
    background-color: #00000008 !important;
    border-color: #e4e7ed !important;
    color: #00000066 !important;
}
.empty-text {
  padding: 10px 0;
  text-align: center;
  color: #999;
}

.no-data-option {
  ::v-deep .el-select-dropdown__item {
    text-align: center;
    color: #999;
    cursor: default;
  }
  
  ::v-deep .el-select-dropdown__item:hover {
    background-color: transparent;
  }
}
</style>